<span class="text-summarizer">
  @if (!!topPosition && !!leftPosition) {
    <pwj-tooltip
      [showsTooltip]="showsTooltip"
      [tooltipText]="tooltipText"
      [topPosition]="topPosition"
      [leftPosition]="leftPosition">
    </pwj-tooltip>
  }

  <span
    class="text-summarizer__content"
    [class.text-summarizer__content--truncate]="truncate()"
    (mouseover)="onHover()"
    (mouseout)="onMouseout()"
    (mousemove)="onMouseMove($event)"
    #textContainer>
    @if (justTooltip()) {
      <ng-content></ng-content>
    } @else if (truncate()) {
      {{ text()?.toString() }}
    } @else {
      {{ text()?.toString() | slice: 0 : limitLength() }}
      @if (text() && (text()?.length || 10) > limitLength()) {
        <span>...</span>
      }
    }
  </span>
</span>
